<!-- ********************************Spinner code start**************************-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple"></ngx-spinner>

  <!-- ************************Delete Rack Data************************** -->

  <div *ngIf="data.type === 'DeleteRackData'" class="deleteRack">
    <div *ngIf="!deleteRackError && !deleteRackSuccess && !confirmDeleteRack">
        <h1 mat-dialog-title>{{'Do you want to delete rack information for' | translate}} "<span *ngFor="let element of data.rackCode">
            ‘{{element}}’
        </span>" ?</h1>

        <div mat-dialog-actions class="fileUploadActionButtons">
            <div>
              <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
              <button class="okButton"  mat-button (click)="askRackDeleteConfirmation()"
                cdkFocusInitial>{{'Delete Rack' | translate}}</button>
            </div>
          </div>
    </div>

    <div *ngIf="confirmDeleteRack">
      <h1 mat-dialog-title>{{'Are you sure you want to delete?' | translate}}?</h1>
      <div mat-dialog-actions class="confirmedUploadAction">
          <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
          <button class="confirmCloseButton"  mat-button (click)="confirmRackDelete()"
          cdkFocusInitial>{{'Confirm' | translate}}</button>
        </div>
  </div>

    <div *ngIf="!deleteRackError && deleteRackSuccess && !confirmDeleteRack">
        <h1 mat-dialog-title>{{'Deletion Completed' | translate}}</h1>
        <div mat-dialog-actions class="confirmedUploadAction">
            <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
          </div>
    </div>
    <div *ngIf="deleteRackError && !deleteRackSuccess">
        <h1 mat-dialog-title>{{'Something Went Wrong' | translate}}</h1>
        <div mat-dialog-actions class="confirmedUploadAction">
            <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
          </div>
      </div>
  </div>
<!-- *******************************Add Rack Data************************************ -->

<div class="addRack" *ngIf="data.type === 'AddRackData'">
  <div *ngIf="!addRackError && !addRackSuccess">
  <!-- <h1 mat-dialog-title>Add Rack Information</h1> -->
  <form class="form" name="rackAddForm" [formGroup]="rackAddForm">
    <h1 mat-dialog-title>{{'Add One Rack Code' | translate}}</h1>
    <mat-table #table [dataSource]="dataSource">

      <ng-container matColumnDef="rackCode">
        <mat-header-cell *matHeaderCellDef>{{'Rack Code' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.rackCode" maxlength="7" minlength="7" name="rackCode"
              [formControl]="rackCodeControl" [(ngModel)]="element.rackCode">
            <mat-error *ngIf="rackCodeControl.invalid">{{getRackErrorMessage(rackCodeControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="drivingDirection">
        <mat-header-cell *matHeaderCellDef> {{'Driving Direction' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.drivingDirection" name="drivingDirection"
              [formControl]="rackdrivingDirectionControl" [(ngModel)]="element.drivingDirection">
            <mat-error *ngIf="rackdrivingDirectionControl.invalid">
              {{getRequiredNumberErrorMessage(rackdrivingDirectionControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="x">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate X' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.x" name="x" [formControl]="rackXControl" [(ngModel)]="element.x">
            <mat-error *ngIf="rackXControl.invalid">{{getRequiredNumberErrorMessage(rackXControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="y">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate Y' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.y" name="y" [formControl]="rackYControl" [(ngModel)]="element.y">
            <mat-error *ngIf="rackYControl.invalid">{{getRequiredNumberErrorMessage(rackYControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="depth">
        <mat-header-cell *matHeaderCellDef> {{'Size Depth(X)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.depth" name="depth" [formControl]="rackDepthControl"
              [(ngModel)]="element.depth">
            <mat-error *ngIf="rackDepthControl.invalid">{{getRequiredNumberErrorMessage(rackDepthControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="width">
        <mat-header-cell *matHeaderCellDef> {{'Size Width(Y)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.width" name="width" [formControl]="rackWidthControl"
              [(ngModel)]="element.width">
            <mat-error *ngIf="rackWidthControl.invalid">{{getRequiredNumberErrorMessage(rackWidthControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="height">
        <mat-header-cell *matHeaderCellDef> {{'Size Height(Z)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.height" name="height" [formControl]="rackHeightControl"
              [(ngModel)]="element.height">
            <mat-error *ngIf="rackHeightControl.invalid">{{getRequiredNumberErrorMessage(rackHeightControl)}}
            </mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="building">
        <mat-header-cell *matHeaderCellDef> {{'Building Number' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <mat-select [formControl]="selectedBuildingNumber" name="selectedBuildingNumber">
              <mat-option *ngFor="let building of buildingNumberList" [value]="building">{{building}}</mat-option>
            </mat-select>
            <mat-error *ngIf="selectedBuildingNumber.invalid">{{getBuildingError(selectedBuildingNumber)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="shelfCount">
        <mat-header-cell *matHeaderCellDef> {{'Shelf Count' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.shelfCount" name="shelfCount" [formControl]="rackShelfCountControl"
              [(ngModel)]="element.shelfCount">
            <mat-error *ngIf="rackShelfCountControl.invalid">{{getRequiredNumberErrorMessage(rackShelfCountControl)}}
            </mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="columnCount">
        <mat-header-cell *matHeaderCellDef> {{'Column Count' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.columnCount" name="columnCount" [formControl]="rackColumnCountControl"
              [(ngModel)]="element.columnCount">
            <mat-error *ngIf="rackColumnCountControl.invalid">{{getErrorMessage(rackColumnCountControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>
      
      <mat-header-row *matHeaderRowDef="displayedRackColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedRackColumns;"></mat-row>
    </mat-table>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
        <button class="okButton" [disabled]="rackAddForm.invalid" mat-button (click)="confirmAdd(data.type)"
          cdkFocusInitial>Add</button>
      </div>
    </div>
  </form>
</div>
<div class="errorsList" *ngIf="addRackError && !addRackSuccess">
    <h1 class="errorHead" mat-dialog-title> {{'Error Found' | translate}}</h1>
    <p class="errorDetails">{{addRackErrorMessage}}</p>
    <div mat-dialog-actions class="confirmedUploadAction">
        <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
      </div>
</div>
<div *ngIf="addRackSuccess && !addRackError">
    <h1 mat-dialog-title>{{'Addition Completed' | translate}}</h1>
    <div mat-dialog-actions class="confirmedUploadAction">
        <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
      </div>
</div>
</div>

<!-- ******************************Delete Nouba ******************************** -->

<div *ngIf="data.type === 'DeleteNoubaData'" class="deleteRack">
  <div *ngIf="!deleteNoubaSuccess && !deleteNoubaError && !confirmDeleteNouba">
      <h1 mat-dialog-title>{{'Do you want to delete nouba information for' | translate}} <span *ngFor="let element of data.noubaCode">
          ‘{{element}}’
      </span> ?</h1>

      <div mat-dialog-actions class="fileUploadActionButtons">
          <div>
            <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
            <button class="okButton"  mat-button (click)="askNoubaDeleteConfirmation()"
              cdkFocusInitial>{{'Delete Nouba' | translate}}</button>
          </div>
        </div>
  </div>
  <div *ngIf="confirmDeleteNouba">
    <h1 mat-dialog-title>{{'Are you sure you want to delete?' | translate}}</h1>
    <div mat-dialog-actions class="confirmedUploadAction">
        <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
        <button class="confirmCloseButton"  mat-button (click)="confirmNoubaDelete()"
        cdkFocusInitial>{{'Confirm' | translate}}</button>
      </div>
</div>
    <div *ngIf="deleteNoubaSuccess && !deleteNoubaError && !confirmDeleteNouba">
        <h1 mat-dialog-title>{{'Deletion Completed' | translate}}</h1>
        <div mat-dialog-actions class="confirmedUploadAction">
            <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
          </div>
    </div>
    <div *ngIf="!deleteNoubaSuccess && deleteNoubaError && !confirmDeleteNouba">
        <h1 mat-dialog-title>{{'Something Went Wrong' | translate}}</h1>
        <div mat-dialog-actions class="confirmedUploadAction">
            <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
          </div>
    </div>
</div>

<!-- ***********************************Nouba***************************** -->

<div class="addNouba" *ngIf="data.type === 'AddNoubaData'">
  <!-- <h1 mat-dialog-title>Add Rack Information</h1> -->
  <div *ngIf="!addNoubaError && !addNoubaSuccess">
  <form class="form" name="noubaAddForm" [formGroup]="noubaAddForm">
    <h1 mat-dialog-title>{{'Add One Nouba Code' | translate}}</h1>
    <mat-table #table [dataSource]="dataSource">

      <ng-container matColumnDef="noubaCode">
        <mat-header-cell *matHeaderCellDef>{{'Nouba Code' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.noubaCode" name="noubaCode" maxlength="3" minlength="3" [formControl]="noubaCodeControl"
              [(ngModel)]="element.noubaCode">
              <mat-error *ngIf="noubaCodeControl.invalid">{{getNoubaErrorMessage(noubaCodeControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="drivingDirection">
        <mat-header-cell *matHeaderCellDef> {{'Driving Direction' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.drivingDirection" name="drivingDirection"
              [formControl]="noubadrivingDirectionControl" [(ngModel)]="element.drivingDirection">
            <mat-error *ngIf="noubadrivingDirectionControl.invalid">
              {{getRequiredNumberErrorMessage(noubadrivingDirectionControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="x">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate X' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.x" name="x" [formControl]="noubaXControl" [(ngModel)]="element.x">
            <mat-error *ngIf="noubaXControl.invalid">{{getRequiredNumberErrorMessage(noubaXControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="y">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate Y' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.y" name="y" [formControl]="noubaYControl" [(ngModel)]="element.y">
            <mat-error *ngIf="noubaYControl.invalid">{{getRequiredNumberErrorMessage(noubaYControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="depth">
        <mat-header-cell *matHeaderCellDef> {{'Size Depth(X)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.depth" name="depth" [formControl]="noubaDepthControl"
              [(ngModel)]="element.depth">
            <mat-error *ngIf="noubaDepthControl.invalid">{{getRequiredNumberErrorMessage(noubaDepthControl)}}
            </mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="width">
        <mat-header-cell *matHeaderCellDef> {{'Size Width(Y)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.width" name="width" [formControl]="noubaWidthControl"
              [(ngModel)]="element.width">
            <mat-error *ngIf="noubaWidthControl.invalid">{{getRequiredNumberErrorMessage(noubaWidthControl)}}
            </mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="building">
          <mat-header-cell *matHeaderCellDef> {{'Building Number' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-form-field>
              <mat-select [formControl]="selectedBuildingNumber" name="selectedBuildingNumber">
                <mat-option *ngFor="let building of buildingNumberList" [value]="building">{{building}}</mat-option>
              </mat-select>
              <mat-error *ngIf="selectedBuildingNumber.invalid">{{getBuildingError(selectedBuildingNumber)}}</mat-error>
            </mat-form-field>
          </mat-cell>
        </ng-container>

      <mat-header-row *matHeaderRowDef="displayedNoubaColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedNoubaColumns;"></mat-row>
    </mat-table>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
        <button class="okButton" [disabled]="noubaAddForm.invalid" mat-button (click)="confirmAdd(data.type)"
          >Add</button>
      </div>
    </div>
  </form>
</div>
  <div class="errorsList" *ngIf="addNoubaError && !addNoubaSuccess">
      <h1 class="errorHead" mat-dialog-title> {{'Error Found' | translate}}</h1>
      <p class="errorDetails">{{addNoubaErrorMessage}}</p>
      <div mat-dialog-actions class="confirmedUploadAction">
          <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
        </div>
  </div>
  <div *ngIf="addNoubaSuccess && !addNoubaError">
      <h1 mat-dialog-title>{{'Addition Completed' | translate}}</h1>
      <div mat-dialog-actions class="confirmedUploadAction">
          <button class="confirmCloseButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
        </div>
  </div>
</div>
